import { type CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

const DEFAULT_COUNTRY: CountryCode = 'ES';

export function formatPhoneNumber(
  phone: string | null | undefined,
  country: CountryCode = DEFAULT_COUNTRY,
): string {
  if (!phone) {
    return '';
  }

  try {
    const parsed = parsePhoneNumberFromString(phone, country);
    if (!parsed) {
      return phone;
    }

    return parsed.formatNational();
  } catch {
    return phone;
  }
}

export function formatInternationalPhoneNumber(
  phone: string | null | undefined,
  country: CountryCode = DEFAULT_COUNTRY,
): string {
  if (!phone) {
    return '';
  }

  try {
    const parsed = parsePhoneNumberFromString(phone, country);
    if (!parsed) {
      return phone;
    }

    return parsed.formatInternational();
  } catch {
    return phone;
  }
}

export function normalizePhoneNumber(
  phone: string,
  country: CountryCode = DEFAULT_COUNTRY,
): string {
  const parsed = parsePhoneNumberFromString(phone, country);
  if (!parsed?.isValid()) {
    return phone;
  }

  return parsed.number;
}
